import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId", "onImageUpload", "children", "minImageHeight", "minImageWidth"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from 'academy-common-lib/utils/UsageTracker';
import { ThumbnailUploader } from '../../cropper/components/ThumbnailUploader';
import { useCallback } from 'react';
import { useSetPlaylistThumbnail } from '../savedItemsQueries';
import Raven from 'raven-js';
import I18n from 'I18n';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { produce } from 'immer';
import { useHasScope } from '../../accounts/accountsQueries';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HAS_CLOSED_PLAYLIST_THUMBNAIL_DISCLAIMER_LOCALSTORAGE_KEY = 'academy:hasClosedPlaylistThumbnailDisclaimer';
export const useClosedPlaylistThumbnailDisclaimer = create()(persist(set => ({
  hasClosedPlaylistThumbnailDisclaimer: false,
  setHasClosedPlaylistThumbnailDisclaimer: value => set(produce(state => {
    state.hasClosedPlaylistThumbnailDisclaimer = value;
  }))
}), {
  name: HAS_CLOSED_PLAYLIST_THUMBNAIL_DISCLAIMER_LOCALSTORAGE_KEY
}));
export const UploadPlaylistThumbnailButton = _ref => {
  let {
      playlistId,
      onImageUpload,
      children,
      minImageHeight,
      minImageWidth
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [setPlaylistThumbnail] = useSetPlaylistThumbnail(playlistId);
  const {
    hasClosedPlaylistThumbnailDisclaimer,
    setHasClosedPlaylistThumbnailDisclaimer
  } = useClosedPlaylistThumbnailDisclaimer();
  const {
    hasScope: canUploadImage
  } = useHasScope('file-manager-write');
  const handleClick = () => {
    UsageTracker.trackStandalone('Playlist Interaction', {
      action: 'upload-playlist-thumbnail-click',
      playlistId
    });
  };
  const handleDisclaimerClose = () => {
    setHasClosedPlaylistThumbnailDisclaimer(true);
    UsageTracker.trackStandalone('Playlist Interaction', {
      action: 'upload-playlist-thumbnail-disclaimer-close-click'
    });
  };
  const handleImageLoad = useCallback((standardPreviewImage, reducedPreviewImage) => {
    if (onImageUpload) onImageUpload();
    setPlaylistThumbnail(standardPreviewImage, reducedPreviewImage).then(() => {
      FloatingAlertStore.addAlert({
        type: 'success',
        message: I18n.text('academyCommon.cropper.uploadSuccess')
      });
    }).catch(error => {
      Raven.captureException(error);
      FloatingAlertStore.addAlert({
        type: 'danger',
        message: I18n.text('academyCommon.cropper.uploadError')
      });
    });
  }, [onImageUpload, setPlaylistThumbnail]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: canUploadImage ? null : I18n.text('academyCommon.playlists.noThumbnailUploadPermission'),
    children: /*#__PURE__*/_jsx(ThumbnailUploader, Object.assign({
      description: /*#__PURE__*/_jsxs(TFlex, {
        direction: "column",
        gap: 12,
        marginBlockEnd: "500",
        children: [/*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyCommon.playlists.thumbnailModalDescription"
          })
        }), !hasClosedPlaylistThumbnailDisclaimer && /*#__PURE__*/_jsx(Alert, {
          closeable: true,
          onClose: handleDisclaimerClose,
          type: "warning",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyCommon.playlists.thumbnailModalDisclaimer"
          })
        })]
      }),
      descriptionReduced: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.playlists.thumbnailModalDescriptionReduced"
      }),
      descriptionStandard: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.playlists.thumbnailModalDescriptionStandard"
      }),
      disabled: !canUploadImage,
      minImageHeight: minImageHeight,
      minImageWidth: minImageWidth,
      onClick: handleClick,
      onImageLoad: handleImageLoad
    }, props, {
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.playlists.uploadPlaylistThumbnail"
      })
    }))
  });
};